
import React from 'react'
import styles from './styles.module.css'

const ViewDeal = ({ dealToView }) => {
  const NA = "Not Available"

  const formatBool = (val) => {
    if (val === null || val === undefined) return NA
    return val ? "Yes" : "No"
  }

  const formatDate = (val) => {
    if (!val) return NA
    return new Date(val).toLocaleString()
  }

  const formatVal = (val) => {
    if (val === null || val === undefined || val === '') return NA
    return String(val)
  }

  return (
    <div className={styles['deal-view-top']}>
      <div><span>Deal Name</span><b>{formatVal(dealToView?.dealname)}</b></div>
      <div><span>HubSpot Deal ID</span><b>{formatVal(dealToView?.HubSpotDealId)}</b></div>
      <div><span>Owner ID</span><b>{formatVal(dealToView?.hubspot_owner_id)}</b></div>
      <div><span>Installer</span><b>{formatVal(dealToView?.installer_name)}</b></div>
      <div><span>Deal Stage</span><b>{formatVal(dealToView?.dealstage)}</b></div>
      <div><span>Pipeline</span><b>{formatVal(dealToView?.pipeline)}</b></div>
      <div><span>Property Address</span><b>{formatVal(dealToView?.property_address)}</b></div>
      <div><span>Property State</span><b>{formatVal(dealToView?.property_state)}</b></div>
      <div><span>Access Model</span><b>{formatVal(dealToView?.access_model)}</b></div>
      <div><span>Section Type</span><b>{formatVal(dealToView?.section_type)}</b></div>
      <div><span>Parking</span><b>{formatVal(dealToView?.parking)}</b></div>
      <div><span>Parking Access</span><b>{formatVal(dealToView?.parking_access)}</b></div>
      <div><span>Software Only</span><b>{dealToView?.software_only ? "Yes": "No"}</b></div>
      <div><span>L2 Chargers</span><b>{formatVal(dealToView?.l2_chargers)}</b></div>
      <div><span>L3 Chargers</span><b>{formatVal(dealToView?.l3_chargers)}</b></div>
      <div><span>LTE Hardware</span><b>{formatVal(dealToView?.lte_hardware)}</b></div>
      <div><span>Pedestals</span><b>{formatVal(dealToView?.pedestals)}</b></div>
      <div><span>Signage</span><b>{formatVal(dealToView?.signage)}</b></div>
      <div><span>Number of Sites</span><b>{formatVal(dealToView?.of_sites)}</b></div>
      <div><span>MUF</span><b>{formatBool(dealToView?.muf)}</b></div>
      <div><span>Site WiFi Available</span><b>{formatBool(dealToView?.site_wifi_available)}</b></div>
      <div><span>Bid Count</span><b>{formatVal(dealToView?.bidCount ?? 0)}</b></div>
      <div><span>Created Date</span><b>{formatDate(dealToView?.createdate)}</b></div>
    </div>
  )
}

export default ViewDeal
